export const LOAD_QVCT_CARTEGORIE = 'LOAD_QVCT_CARTEGORIE'
export const ADD_QVCT_CARTEGORIE = 'ADD_QVCT_CARTEGORIE'
export const LOAD_QVCT_CARTEGORIE_TYPE = 'LOAD_QVCT_CARTEGORIE_TYPE'